var Curriculog = Curriculog || {};

Curriculog.UserImportRow = (function ($, _, Backbone, UserImportRow) {

    UserImportRow = Backbone.View.extend({
        template: 'Settings/userImportRow.html',

        events: {
            'click .delete button': 'delete',
            'change .first_name input': 'checkFirstName',
            'keyup .first_name input': 'checkFirstName',
            'change .last_name input': 'checkLastName',
            'keyup .last_name input': 'checkLastName',
            'change .email input': 'checkEmail',
            'keyup .email input': 'checkEmail',
            'change .password input': 'checkPassword',
            'keyup .password input': 'checkPassword',
            'change .username input': 'checkUsername',
            'keyup .username input': 'checkUsername',
            'change input': 'styleRow',
            'keyup input': 'styleRow',
        },

        initialize: function(options, flyout) {
            this.save_promise = null;
            this.flyout = flyout;
            this.model = {
                firstname: options.firstname,
                lastname: options.lastname,
                email: options.email.toLowerCase(),
                password: options.password,
                username: options.username,
            };
            this.params = options.params;
            this.render();
        },

        render: function() {
            var $html = $(nunjucks.render(this.template, {cui_enabled: this.params.cui_enabled}));
            this.setElement($html);

            this.$('.first_name input').val(this.model.firstname);
            this.$('.last_name input').val(this.model.lastname);
            this.$('.email input').val(this.model.email);
            this.$('.password input').val(this.model.password);
            this.$('.username input').val(this.model.username);
        },

        recheck: function() {
            this.checkEmail();
            this.checkUsername();
            this.styleRow();
        },

        containsUnicode: function(string) {
            var ascii = /^[ -~]+$/;
            return string !== '' && !ascii.test(string);
        },

        clearError: function($input) {
            $input.parent().removeClass('error');
            $('.error', $input.parent()).remove();
        },

        checkUnicode: function($input) {
            if (this.containsUnicode($input.val())) {
                $input.parent().append('<div class="error">Contains Unicode</div>');
            }
        },

        styleRow: function() {
            this.$el.removeClass('error');
            if (this.$('.error').length) {
                this.$el.addClass('error');
            }
            this.flyout.onRowChange();
        },

        checkFirstName: function() {
            var $input = this.$('.first_name input');
            this.model.firstname = $input.val().trim();
            this.clearError($input);
            this.checkUnicode($input);

            if (!$input.val().length) {
                this.addError($input, 'Required');
            }
        },

        checkLastName: function() {
            var $input = this.$('.last_name input');
            this.model.lastname = $input.val().trim();
            this.clearError($input);
            this.checkUnicode($input);

            if (!$input.val().length) {
                this.addError($input, 'Required');
            }
        },

        checkPassword: function() {
            var $input = this.$('.password input');
            this.model.password = $input.val();
            this.clearError($input);
            this.checkUnicode($input);

            if ($input.val().length < 8) {
                this.addError($input, 'Too short');
            }
        },

        checkUsername: function() {
            var $input = this.$('.username input');
            var val = this.model.username = $input.val().trim();

            this.clearError($input);
            this.checkUnicode($input);

            if (!val.length) {
                return;
            }

            if (this.flyout.isExisting({username: val.toLowerCase()})) {
                this.addError($input, 'Already in use');
            }

            if (this.flyout.isDuplicate({username: val.toLowerCase()})) {
                this.addError($input, 'Duplicate');
            }
        },

        checkEmail: function() {
            var $input = this.$('.email input');
            var val = this.model.email = $input.val().toLowerCase().trim();

            this.clearError($input);
            this.checkUnicode($input);

            if (this.flyout.isExisting({email: val})) {
                this.addError($input, 'Already in use');
            }

            if (this.flyout.isDuplicate({email: val})) {
                this.addError($input, 'Duplicate');
            }

            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(val)) {
                this.addError($input, 'Invalid');
            }
        },

        addError: function($input, message) {
            $input.parent().addClass('error');
            $input.parent().append('<div class="error">' + message + '</div>');
        },

        save: function() {
            var data = {
                firstName: this.model.firstname,
                lastName: this.model.lastname,
                email: this.model.email,
                password: this.model.password,
                userName: this.model.username,
                status: 'active',
            };
            return $.post('/account.json', JSON.stringify(data));
        },

        delete: function() {
            this.flyout.deleteRow(this);
        },
    });

    return UserImportRow;

})($, _, Backbone, Curriculog.UserImportRow || {});
